namespace Gamification.Gamification {
    export interface UtentiProdottiClassificheRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoClassifica?: number;
        IdUtenteProdotto?: number;
        IdentifierUtenteProdottoClassifica?: string;
        IdProdottoEsperienza?: number;
        Tipo?: number;
        Nome?: string;
        Limitazione?: number;
        IdProdottoEsperienzaNome?: string;
    }

    export namespace UtentiProdottiClassificheRow {
        export const idProperty = 'IdUtenteProdottoClassifica';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.UtentiProdottiClassifiche';
        export const lookupKey = 'Gamification.UtentiProdottiClassifiche';

        export function getLookup(): Q.Lookup<UtentiProdottiClassificheRow> {
            return Q.getLookup<UtentiProdottiClassificheRow>('Gamification.UtentiProdottiClassifiche');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoClassifica = "IdUtenteProdottoClassifica",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdentifierUtenteProdottoClassifica = "IdentifierUtenteProdottoClassifica",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            Tipo = "Tipo",
            Nome = "Nome",
            Limitazione = "Limitazione",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome"
        }
    }
}
